import script from "./Xiaomai.vue?vue&type=script&setup=true&lang=js"
export * from "./Xiaomai.vue?vue&type=script&setup=true&lang=js"

import "./Xiaomai.vue?vue&type=style&index=0&id=05920030&lang=less&scoped=true"
script.__scopeId = "data-v-05920030"

export default script